import { SectionServicesListingProps } from '@portfolio/models'
import { FC } from 'react'
import { Link, Pill, SectionWrapper } from '@portfolio/components'
import { styled } from '@portfolio/styles'
import { useTranslation } from 'react-i18next'

const StyledSectionWrapper = styled(SectionWrapper, {
  color: '$white',
  paddingTop: '96',

  '@lg': {
    paddingTop: '$144',
  },
})

const Content = styled('div', {
  margin: '0 auto',
  containerSpace: 'medium',
  width: '100%',
})

const SectionTitle = styled('h2', {})

const ServiceGroupTitle = styled('span', {
  display: 'block',
  projectFont: 'heading08',
  marginBottom: '$40',
})

const ServicesBlocksList = styled('ul', {
  display: 'grid',
  listStyleType: 'none',
  gap: '$40 $0',
  gridTemplateColumns: '1fr',

  '@media (min-width: 675px)': {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  '@lg': {
    gridTemplateColumns: 'repeat(4, 1fr)',
  },
})

const ServicesList = styled('ul', {
  listStyleType: 'none',
  display: 'grid',
  gap: '$8',
})

const LinkWrap = styled('div', {
  marginTop: '$64',
  display: 'flex',
  justifyContent: 'center',

  '@media (min-width: 675px)': {
    justifyContent: 'flex-start',
  },
})

export const SectionServicesListing: FC<SectionServicesListingProps> = ({
  cta,
  ctaLabel,
  servicesList,
}) => {
  const { t } = useTranslation('servicesListing')

  if (!servicesList.length) return null

  return (
    <StyledSectionWrapper type="NO_MARGIN">
      <SectionTitle className="sr-only">{t('title')}</SectionTitle>
      <Content>
        <ServicesBlocksList>
          {servicesList?.map((servicesListItem, listIndex) => {
            const serviceGroupId = `service-group-${
              servicesListItem?._key || listIndex
            }`

            return servicesListItem?.services ? (
              <li key={servicesListItem?._key || serviceGroupId}>
                {servicesListItem?.title && (
                  <ServiceGroupTitle id={serviceGroupId}>
                    {servicesListItem?.title}
                  </ServiceGroupTitle>
                )}
                <ServicesList
                  aria-labelledby={
                    servicesListItem?.title ? serviceGroupId : undefined
                  }
                >
                  {servicesListItem?.services?.map((service, serviceIndex) => (
                    <li
                      key={
                        service
                          ? `${service}-${serviceIndex}`
                          : `service-${serviceIndex}`
                      }
                    >
                      <Pill appearance="UI05">{service}</Pill>
                    </li>
                  ))}
                </ServicesList>
              </li>
            ) : null
          })}
        </ServicesBlocksList>

        <LinkWrap>
          {cta && (
            <Link {...cta} appearance="containedTransparent">
              {ctaLabel}
            </Link>
          )}
        </LinkWrap>
      </Content>
    </StyledSectionWrapper>
  )
}
